import React from "react";

export const FormFieldName = ({ text = "", minWidth = 160 }) => {
  return (
    <span className="lf-form-name" style={{ minWidth }}>
      {text}
    </span>
  );
};
